module.exports = __webpack_public_path__ + "static/img/modal-bg.84520c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/limit-activity/modal-bg.png
// module id = /SDW
// module chunks = 215